import type { HelpFaqProps } from '@/components/help/HelpFaq';
import { HelpFaq } from '@/components/help/HelpFaq';

const helpFaqData: HelpFaqProps = {
  title: 'Shipping & Payment',
  subtitle: 'How we charge?',
  faq: [
    {
      question: 'Free service and shipping',
      answer: (
        <>
          <p>
            There's no additional cost for using our service - all service costs
            are included in the prices of our products. As an EternaLife
            customer, here's what you will pay for:
          </p>
          <h3>Shipping</h3>
          <p>Orders placed after 12pm will process next working day.</p>
          <ul>
            <li>Free Lithuania shipping on orders over €150</li>
            <li>Free Europe shipping on orders €200+</li>
            <li>Free shipping worldwide on orders €300+</li>
          </ul>
          <p>
            For International shipping, any import duties, taxes, handling fees
            due at the time of delivery, are the sole responsibility of the
            customer receiving the order.
          </p>
          <h3>Your subscription</h3>
          <p>
            Your first supplement subscription will appear when your EternaLife
            account is verified and you confirm the order of a supplement set
            tailor-made for you or submit a custom order. You will see the price
            of month's supplement supply and the total price for the
            subscription period. We will apply any discounts available at that
            time in order for you to pay the best price. To request the price
            summary, please contact us.
          </p>
        </>
      ),
    },
    {
      question: 'Managing your subscriptions',
      answer: (
        <>
          <p>
            We fill supplement subscriptions on a 30-day cycle, rather than
            90-day. This is because we understand supplements, strengths, and
            doses may change. Filling monthly allows us to quickly accommodate
            any adjustments for your next order. That way, you don't have to
            throw out two months of supplements any time there's a change.
          </p>
          <p>
            We will notify you via email or phone call five days before your
            subscription expires. To continue with your current or new
            subscription, simply make a payment. Failure to do so will result in
            the cancellation of your subscription.
          </p>
        </>
      ),
    },
  ],
};

export const ShippingPage = () => {
  return <HelpFaq {...helpFaqData} />;
};
